/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocIcon16Light = forwardRef('DocIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 1A2.5 2.5 0 0 0 3 3.5v8A2.5 2.5 0 0 0 5.5 14h5a2.5 2.5 0 0 0 2.5-2.5V5.485a1.5 1.5 0 0 0-.44-1.06L9.577 1.438A1.5 1.5 0 0 0 8.516 1H5.5ZM4 3.5A1.5 1.5 0 0 1 5.5 2H8v2.5A1.5 1.5 0 0 0 9.5 6H12v5.5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 11.5v-8ZM11.722 5 9 2.278V4.5a.5.5 0 0 0 .5.5h2.222Z" })));
});
